// extracted by mini-css-extract-plugin
module.exports = {"container":"_404-module_container","title":"_404-module_title","link":"_404-module_link","view":"_404-module_view"};